import { app } from '../../app';

app.run(init);

/** @ngInject */
function init($rootScope, $transitions) {
    $transitions.onStart({}, (transition) => $rootScope.transition = transition);
}



// WEBPACK FOOTER //
// ./src/portal/init/ui-router/transition.js